import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";

export default function RedirectIfAuth({ children, to = "/search", allowIf }) {
  const { user, me, subscription, loading } = useAuth();

  if (loading) return <div style={{ padding: "2rem" }}>Loading…</div>;

  const allowed =
    typeof allowIf === "function" ? allowIf({ user, me, subscription }) : false;

  if (user && !allowed) return <Navigate to={to} replace />;

  return children;
}
